import React, {useEffect, useState, lazy, Suspense} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, Card, Dialog, DialogTitle, IconButton} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import BBIconPrinterOutput from "../../../assets/bbCustomIcons/BBIconPrinterOutput";
import CloseIcon from "@material-ui/icons/Close";
import {CircularProgress, DialogContent, } from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import {
    bbDangerousStringToDate, bbDictionaryOfTargetDiscoverySources,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString, bbTranslateBreachRiskScoreToCategory, bbTranslateBreachRiskScoreToColor
} from "../../../util/bbHelpers";
import {fetchRiskCycleReport, fetchTargetDetails} from "../../../actions";
import BRVectorCardsDialog from "../BreachRiskReport/BRVectorCardsDialog";
import BBExternalLink from "../accents/BBExternalLink";
import Skeleton from "react-loading-skeleton";
import TargetDetailsCrawlTable from "./TargetDetailsCrawlTable";
import BBIconHostInspectorMagnifyingGlassDatabase
    from "../../../assets/bbCustomIcons/BBIconHostInspectorMagnifyingGlassDatabase";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";

const BRTechTargetDetailsModal = ({targetId = null, cycleId=null}) =>{

    // const BRTargetDetailCards = lazy(()=> import("./BRTargetDetailCards"))

    const dispatch = useDispatch();
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingCycleTargets, loadingCycleTargetsError, loadingCycles, loadingCyclesError} = useSelector(({breachrisk}) => breachrisk);

    const {authUser} = useSelector(({auth}) => auth);

    const [open, setOpen] = useState(false);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    // console.log("BRTechTargetDetailsModal here is myEntity", myEntity);

    const lastCycle = myEntity
        && myEntity.cycles
        && myEntity.settings
        && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;
    // console.log("BRTechTargetDetailsModal here is lastCycle", lastCycle);
    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    useEffect(()=>{
        if(pastReportView && !loadingCycles[cycleId]){
            if (cycleId
                && myEntity
                && myEntity.cycles
                && !myEntity.cycles[cycleId]) {
                dispatch(fetchRiskCycleReport({
                    customerId: customerIdToUse,
                    cycleId: cycleId
                }))
            }
        }
    }, [cycleId, pastReportView])

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const targets = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.targets : null;

    // console.log("BRTechTargetDetailsModal here is targets", targets);

    // console.log("BRTechTargetDetailsModal Looking for target", targetId);
    const indexOfTargetId = targets && targets.findIndex(x => x.Id === targetId);
    const target = (loadingCycleTargets && !loadingCycleTargets[targetId]) && targets && targets[indexOfTargetId];

    const source = target ? bbDictionaryOfTargetDiscoverySources[target.Source] : null;

    // console.log("BRTechTargetDetailsModal target is", target);
    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;

    const threatVectors = techData
    && techData.totals
    && techData.totals.vectors
        ? techData.totals.vectors : null;

    const totalNumThreatVectors = techData
        && techData.meta
        ? techData.meta.vectors_to_send
        : null;

    const vectorsAssociatedWithTarget = target
        && threatVectors
        && Array.isArray(threatVectors)
        && threatVectors
            .filter((vector)=> vector.target === target.Id)

    const targetHasVectors = vectorsAssociatedWithTarget
        && vectorsAssociatedWithTarget.length > 0;

    // console.log("does this target have any realted vectors? ", vectorsAssociatedWithTarget, threatVectors)

    // target.Vulnerabilities && console.log(target.Vulnerabilities)
    const hasScans = target
        && target.scans
        && Object.keys(target.scans).length > 0;
    const scans = hasScans
        && Object.values(target.scans);

    // hasScans && console.log("this is scans", scans, typeof scans[0], typeof scans[0].results, JSON.parse(scans[1].results))
    // console.log("targetId",targetId, "indexOFTargetId", indexOfTargetId, "target", target)

    const [targetHasUpdatedDetails, setTargetHasUpdatedDetails] = useState(!!(target && target.recon));
    // console.log("targetHasUpdateDetails", targetHasUpdatedDetails)

    const targetTagsArray = target
        && target.Tags
        && Object.values(target.Tags);

    const tagNamesArray = targetTagsArray
        && targetTagsArray
            .map((tag)=> tag && tag.definition && tag.definition.name);
    const uniqueTagNamesArray = [...new Set(tagNamesArray)]



    useEffect(()=>{
        if(open){
            // console.log("BRTechTargetDetailsModal open", targetId, "this is target", target)
            if(target && !targetHasUpdatedDetails){
                // console.log("BRTechTargetDetailsModal useEffect called");
                dispatch(fetchTargetDetails({
                    targetId: targetId,
                    entityId: entityInView,
                    customerId: customerIdToUse
                }));
                setTargetHasUpdatedDetails(!!(target && target.recon));
            }
        }

        setTargetHasUpdatedDetails(!!(target && target.recon));

    }, [open, target, targetHasUpdatedDetails, loadingCycleTargets])

    return(
        <div>
            <Tooltip title={"Inspect Host"}>
                <IconButton
                    onClick={()=> setOpen(true)}
                >
                    <BBIconHostInspectorMagnifyingGlassDatabase/>
                </IconButton>
            </Tooltip>


            <Dialog open={open}
                    fullWidth={true}
                    fullScreen={false}
                    maxWidth={"lg"}
                    className={"m-1 p-1 animated fadeIn animation-duration-6"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>window.print()}
                                style={{ margin: "0", padding: "0", alignItems: "center", alignContent: "center"}}>
                                <BBIconPrinterOutput
                                    className={"mb-2 close"}
                                />
                            </IconButton>
                            {/*</Col>*/}
                            &nbsp;
                            &nbsp;
                            {/*<Col lg={1} className={"text-right"}>*/}
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent>
                    {/*<Suspense fallback={    <div style={{height: "200px", width: "600px"}}>*/}
                    {/*    <Row  style={{width: "100%"}}>*/}
                    {/*        <h1 className={"m-1 darken-1 jr-card-title"}>*/}
                    {/*            {target.IpAddress}*/}
                    {/*        </h1>*/}
                    {/*    </Row>*/}
                    {/*    <Row>*/}
                    {/*        <Col>*/}
                    {/*            <h2>*/}
                    {/*                <Skeleton count={6}/>*/}
                    {/*            </h2>*/}
                    {/*        </Col>*/}
                    {/*    </Row>*/}
                    {/*</div>}>*/}
                        {/*<BRTargetDetailCards targetId={targetId}/>*/}
                    {/*</Suspense>*/}
                    {target && targetHasUpdatedDetails ?

                        <div>
                            <Card className={"p-0 m-0"}>
                                <div className={"card-header mb-0 pb-0 d-print-table"}>
                                    <Row  style={{width: "100%"}} className={""}>
                                        <h2 className={"m-1 darken-1 jr-card-title "}>
                                            {target.IpAddress ? target.IpAddress : "Host Unknown"}
                                        </h2>
                                    </Row>
                                    <Row className={""}>
                                        <Col lg={6} className={"text-center align-self-center"}>
                                            {target.Discovered &&
                                                <p className={""}>
                                                    <small>
                                                        Discovered by BreachBits on {bbFormattedDateString(target.discovered_datetime, "shortFullMonth")}
                                                    </small>
                                                </p>}

                                        </Col>
                                        <Col lg={6} className={"text-right align-self-center"}>
                                                    <p>
                                                        <small>
                                                            Discovery Source:&nbsp;
                                                            {source && source.image && source.id !== 1
                                                                ? <Tooltip title={source && source.description
                                                                    ? source.description : null}>
                                                        <span>
                                    <img style={{height: 30, maxWidth:80}}
                                         className={"rounded bg-white p-0 m-1 mr-2"}
                                         src={source.image}
                                         alt={source.description}/>
                                  </span>
                                                                </Tooltip>
                                                                : source
                                                                && source.id === 1
                                                                && myEntity
                                                                && myEntity.logo_url
                                                                    ? <Tooltip title={source && source.description
                                                                        ? source.description : null}>
                                                                        <img style={{height: 30, maxWidth:80}}
                                                                             className={"rounded bg-white p-0 m-1 mr-2"}
                                                                             src={myEntity.logo_url}
                                                                             alt={source.name}/>
                                                                    </Tooltip>
                                                                    :<Tooltip title={source && source.description
                                                                        ? source.description : null}>
                                  <span>
                                    <Tooltip title={source.description}>
                                        <span>
                                            <BBIconEmptyBox className={"rounded bg-white p-0 m-1 mr-2"}
                                                            style={{fontSize: "20px"}}/>
                                        </span>
                                    </Tooltip>
                                  </span>
                                                                    </Tooltip>
                                                            }
                                                        </small>
                                                    </p>
                                                </Col>
                                            </Row>
                                </div>
                                {target && target.recon &&
                                <div className={""}>
                                    <Row className={"float-right m-1 p-1"}>
                                        <Col >
                                            {target
                                            && targetTagsArray
                                            && Array.isArray(targetTagsArray)
                                            && targetTagsArray.length > 0
                                                ? uniqueTagNamesArray.map((tag, index)=> (
                                                    <p key={index} className={"tag-chip"}>
                                                            {tag.toUpperCase()}
                                                        </p>
                                                ))
                                                : null}
                                        </Col>
                                    </Row>
                                <br/>
                                    <Row className={""}>
                                        <Col className={"ml-2 mt-1 "}>
                                            <h4 className={""}>
                                                Registered Information:
                                            </h4>
                                        </Col>
                                    </Row>
                                    <Row className={"m-1 p-1 "}>
                                        <Col lg={3} className={"d-print-table-row"}>
                                            <Row className={"d-print-table-cell"}>
                                                <Col lg={4} className={"d-print-inline"}>
                                                    Location:
                                                </Col>
                                                <Col lg={8} className={"d-print-inline"}>
                                                    {target.recon.city ? target.recon.city : "--"}, {target.recon.state ? target.recon.state : "--"}, {target.recon.country ? target.recon.country : "--"}
                                                </Col>
                                            </Row>

                                        </Col>
                                        <Col lg={3} className={"d-print-table-row"}>
                                            <Row className={"d-print-table-cell"}>
                                                <Col lg={6} className={"d-print-inline"}>
                                                    Network Range:
                                                </Col>
                                                <Col lg={6} className={"d-print-inline"}>
                                                    {target.recon.reg_cidr ? target.recon.reg_cidr : "--"}
                                                </Col>
                                            </Row>

                                        </Col>
                                        <Col lg={3} className={"d-print-table-row"}>
                                            <Row className={"d-print-table-cell"}>
                                                <Col lg={4} className={"d-print-inline"}>
                                                    Organization:
                                                </Col>
                                                <Col lg={8} className={"d-print-inline"}>
                                                    {target.recon.reg_org_name ? target.recon.reg_org_name : "--"}
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col lg={3} className={"d-print-table-row"}>
                                            <Row className={"d-print-table-cell"}>
                                                <Col lg={4} className={"d-print-inline"}>
                                                    Point of Contact:
                                                </Col>
                                                <Col lg={8} className={"d-print-inline-flex"}>
                                                    {target.recon.reg_org_poc ? target.recon.reg_org_poc : "--"}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className={"bg-lighter-gray border border-dark m-0 p-0 "}>
                                        <Row className={"d-print-table"}>
                                            <Col lg={4} className={"border-right border-dark d-print-row"}>
                                                <Row className={"d-print-table-cell"}>
                                                    <Col className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>Ports:</p>
                                                    </Col>
                                                    <Col lg={8} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline-flex"}>
                                                            {target.Ports && Array.isArray(target.Ports) && target.Ports.length > 0
                                                                ? target.Ports.map((port, index)=> {
                                                                    if(index + 1 !== target.Ports.length){
                                                                        return(
                                                                            <span key={`${port}_${index}`}>{port}, </span>
                                                                        )
                                                                    } else{
                                                                        return(
                                                                            <span key={`${port}_${index}`}>{port} </span>
                                                                        )
                                                                    }})
                                                                : <span> -- </span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col lg={4} className={"border-right border-dark "}>
                                                <Row className={"d-print-table-row"}>
                                                    <Col lg={4} className={"d-print-table-cell"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>Subdomains:</p>
                                                    </Col>
                                                    <Col lg={8} className={"d-print-inline"}>
                                                        {/*<p> {target.ports}</p>*/}
                                                        <p className={"m-1 p-1 d-print-inline-flex"}>
                                                            {target.subdomains && Object.values(target.subdomains).length > 0
                                                                ? Object.values(target.subdomains)
                                                                    .map((subdomain, index)=> {
                                                                        if(index + 1 !== Object.values(target.subdomains).length){
                                                                            return(
                                                                                <span key={subdomain.id}>{subdomain.subdomain}, </span>
                                                                            )
                                                                        } else{
                                                                            return(
                                                                                <span key={subdomain.id}>{subdomain.subdomain} </span>
                                                                            )
                                                                        }})
                                                                : <span> -- </span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>

                                            <Col lg={4} className={""}>
                                                <Row className={"d-print-table-row"}>
                                                    <Col lg={4} className={"d-print-table-cell"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>Domains:</p>
                                                    </Col>
                                                    <Col lg={8} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline-flex"}>
                                                            {target.Fqdn && Array.isArray(target.Fqdn) && target.Fqdn.length > 0
                                                                ? target.Fqdn.map((fqdn, index)=> {
                                                                    if(index + 1 !== target.Fqdn.length){
                                                                        return(
                                                                            <span key={`${fqdn}_${index}`}>{fqdn}, </span>
                                                                        )
                                                                    } else{
                                                                        return(
                                                                            <span key={`${fqdn}_${index}`}>{fqdn} </span>
                                                                        )
                                                                    }})
                                                                : <span> -- </span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row className={"border-top border-dark m-0 p-0"}>
                                            <Col lg={6} className={"border-right border-dark d-print-table-row"}>
                                                <Row className={"d-print-table-cell"}>
                                                    <Col lg={4} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>
                                                            Services:
                                                        </p>
                                                    </Col>
                                                    <Col lg={8} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>
                                                            {target.Services && Array.isArray(target.Services) && target.Services.length > 0
                                                                ? target.Services.map((service, index)=> {
                                                                    if(index + 1 !== target.Services.length){
                                                                        return(
                                                                            <span key={service.id}>{service}, </span>
                                                                        )
                                                                    } else{
                                                                        return(
                                                                            <span key={service.id}>{service} </span>
                                                                        )
                                                                    }})
                                                                : <span> -- </span>
                                                            }
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col lg={6} className={"d-print-table-row"}>
                                                <Row className={"d-print-table-cell"}>
                                                    <Col lg={4} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline"}>Vulnerabilities:</p>
                                                    </Col>
                                                    <Col lg={8} className={"d-print-inline"}>
                                                        <p className={"m-1 p-1 d-print-inline-flex"}>
                                                            {target.Vulnerabilities && Array.isArray(target.Vulnerabilities) && target.Vulnerabilities.length > 0
                                                                ? target.Vulnerabilities.map((vuln, index)=> (
                                                                    <p className={"m-0 p-0"}> <BBExternalLink
                                                                        key={`${vuln}${index}`}
                                                                        href={`https://nvd.nist.gov/vuln/detail/${vuln}`}
                                                                        tipText={`Read more about ${vuln} at the NIST National Vulnerability Database.`}>
                                                                        {vuln}
                                                                    </BBExternalLink>
                                                                    </p>))
                                                                : <span> -- </span>
                                                            }

                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/*<Row className={"border-top border-dark m-0 p-0"}>*/}
                                            {/*<Col lg={4} className={"d-print-inline text-center"}>*/}
                                            {/*    <p className={"m-1 p-1 d-print-inline"}>Tech Types: </p>*/}
                                            {/*</Col>*/}
                                            {/*<Col lg={8} className={"d-print-inline "}>*/}
                                            {/*    <p className={"m-1 p-1 d-print-inline-flex"}>*/}
                                            {/*        {target && targetTagsArray && Array.isArray(targetTagsArray) && targetTagsArray.length > 0*/}
                                            {/*            ? targetTagsArray.map((tag, index)=> {*/}
                                            {/*                if(index + 1 !== targetTagsArray.length){*/}
                                            {/*                    return(*/}
                                            {/*                        <span key={tag.id}>{tag && tag.definition && tag.definition.name}, </span>*/}
                                            {/*                    )*/}
                                            {/*                } else{*/}
                                            {/*                    return(*/}
                                            {/*                        <span key={tag.id}>{tag && tag.definition && tag.definition.name} </span>*/}
                                            {/*                    )*/}
                                            {/*                }})*/}
                                            {/*            : <span> -- </span>}*/}
                                            {/*    </p>*/}
                                            {/*</Col>*/}
                                        {/*</Row>*/}
                                    </div>
                                    {/*<Row className={"float-right m-1 p-1"}>*/}
                                    {/*    <Col >*/}
                                    {/*        {target && targetTagsArray && Array.isArray(targetTagsArray) && targetTagsArray.length > 0*/}
                                    {/*            ? uniqueTagNamesArray.map((tag, index)=> (*/}
                                    {/*                <span key={index}*/}
                                    {/*                      style={{ backgroundColor: "#e9ecef",*/}
                                    {/*                          border: "1px groove #dee2e6",*/}
                                    {/*                          borderRadius: "10px", margin: "2px", paddingRight: "2px", paddingLeft: "2px"*/}
                                    {/*                        }}>*/}
                                    {/*                        {tag}*/}
                                    {/*                    </span>*/}
                                    {/*            ))*/}
                                    {/*            : null}*/}
                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                </div>}
                            </Card>
                            <br/>

                            {threatVectors && targetHasVectors && vectorsAssociatedWithTarget && Array.isArray(vectorsAssociatedWithTarget) &&
                            <Card className={"m-0 p-0 d-print-table"}>
                                <Row className={"card-header"}>
                                    <h3>Vectors Associated With This Target</h3>
                                </Row>
                                <Row className={"text-center ml-1 pl-1"} style={{width: "100%"}} >
                                    {vectorsAssociatedWithTarget.map((vector) => {
                                        const vectorScore = vector && vector.score;
                                        const vectorDef = vector && vector.definition;
                                        const vectorDefName = vector && vectorDef && vectorDef.name ? vectorDef.name : "--";

                                        const dot = <path d="m86 50c0 19.883-16.117 36-36 36s-36-16.117-36-36 16.117-36 36-36 36 16.117 36 36"/>
                                        const color = bbTranslateBreachRiskScoreToColor(vector.score, true)
                                        const category = bbTranslateBreachRiskScoreToCategory(vector.score)

                                        return(
                                        <Col key={vector.id} className={"d-inline text-center align-self-center m-0 p-0"}>
                                            <p className={"d-inline m-2 p-2 text-center" } style={{fontSize: ".8rem"}}>
                                                <svg x={-10} y={-10} width={20} height={20} fill={color} viewBox="0 0 100 100">{dot}</svg>
                                                {/*{vectorDefName}*/}
                                                <BRVectorCardsDialog vectorId={vector.id} className={"d-print-none"} cycleId={cycleInView.id}/>
                                            </p>
                                        </Col>
                                    )})
                                    }
                                </Row>
                            </Card>
                            }
                            <br/>

                            {hasScans &&
                            <Card className={"m-0 p-0"}>
                                <Row className={"card-header"}>
                                    <h3>
                                        Crawls Discovery
                                    </h3>
                                </Row>
                                <TargetDetailsCrawlTable scans={scans}/>

                            </Card>}

                        </div>


                        :
                    <Card className={"m-0 p-0 animated fadeIn animation-duration-12"}>
                        {!targetHasUpdatedDetails &&
                        <div style={{width:"100%"}}>
                                    Loading Host Details...
                            <Row>
                                <Col>
                                    <h2>
                                        <Skeleton count={6}/>
                                    </h2>
                                </Col>
                            </Row>
                        </div>
                        }
                    </Card>}
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default BRTechTargetDetailsModal;